
import easytixLogo from "../assets/easytix/Logo.png";
import easytixLoaderLogo from "../assets/easytix/Icon.png";
import hormesisLogo from "../assets/hormesis_logo.png";
import radicalLogo from "../assets/radical-logo-2.svg";
import zoaLogo from "../assets/zoa_logo.jpeg";
import minkovskyLogo from "../assets/minkovsky.png";
import comedyClubLogo from "../assets/ccclogo.png";
import nimiLogo from "../assets/logo.png";
import asshLogo from "../assets/ash_logo.png";
import asshLoaderLogo from "../assets/ash_loader_logo.png";
import accadiaLogo from "../assets/accadia_logo.png";
import adifplusLogo from "../assets/adifplus_logo.svg";
import tixwLogo from "../assets/tixw_logo.png";
import bambooClubLogo from "../assets/bambooclub.png";
import articketLogo from "../assets/articket_logo.png";
import demoIcon from "../assets/easytix/tanachi/tanachi-icon.png";
import demoLogo from "../assets/easytix/tanachi/tanach-logo.png";
import flexLogo from "../assets/flex-logo.png";
import getnimiLogo from "../assets/getnimi_logo.svg";
import fireflyLogo from "../assets/firefly_logo.png";
import michaellouiseLogo from "../assets/michaellouise_logo.png";
import circlesLogo from "../assets/circles/logo.png";
import circlesLoaderLogo from "../assets/circles/logo-loader.png";
import cloudtlvLogo from "../assets/cloudtlv_logo.png";
import cloudtlvAuthImage from "../assets/auth/cloudtlv_auth.png";
import cloudtlvAuthImageMobile from "../assets/auth/cloudtlv_auth_mobile.png";
import bohemaClubLogo from "../assets/bohemaclub_logo.svg";
import { getSellerPageLoaderImage } from "./seller";

import DefaultTermsOfService from '../assets/docs/nimi-terms-of-services.pdf'
import DefaultPrivacyPolicy from '../assets/docs/nimi-privacy-policy.pdf'

import { createMarketplaceLoader } from "../components/minimal/loading-screen/MarketplaceLoader";

const bootstrapData = {
    'easytix.co.il': {
        name: 'EASYTIX',
        favicons: {
            apple: "/favicon_easytix/apple-touch-icon.png",
            large: "/favicon_easytix/favicon-32x32.png",
            small: "/favicon_easytix/favicon-16x16.png"
        },
        logo: {
            path: easytixLogo,
            width: "auto",
            height: "70px"
        },
        loader: {
            logo: easytixLoaderLogo,
            width: "auto",
            height: "70px"
        },
        landingPageCta: "/auth/start-selling",
        i18n: {
            en: {
                terminology: {
                    'home.name': 'EASYTIX',
                    'home.title': 'Ticket sales and event management for customers with special requirements',
                    'home.subtitle': 'Including seating, ticket scanning app and sales statistics',
                    'home.main_cta': 'Start selling',
                    'auth.start_selling_success_message': 'Successfully registered! 🎉',
                    'auth.start_selling_success_message_description': 'Our team will review the details and approve you so you can start processing customers\nIn the meantime, you can start creating events 🚀'
                }
            },
            he: {
                terminology: {
                    'home.name': ' EASYTIX ',
                    'home.title': 'מכירת כרטיסים וניהול אירועים ללקוחות עם דרישות מיוחדות',
                    'home.subtitle': 'כולל הושבה, אפליקציית סריקת כרטיסים וסטטיסטיקות מכירות',
                    'home.main_cta': 'התחל למכור',
                    'auth.start_selling_success_message': 'נרשמתם בהצלחה! 🎉',
                    'auth.start_selling_success_message_description': 'הצוות שלנו יעבור על הפרטים ויאשר אתכם כדי שתוכלו להתחיל לסלוק לקוחות\nבינתיים אתם יכולים להתחיל ליצור אירועים 🚀'
                }
            }
        }
    },
    'hormesis.club': {
        name: 'HORMESIS',
        favicons: {
            apple: "/favicon_hormesis/apple-touch-icon.png",
            large: "/favicon_hormesis/favicon-32x32.png",
            small: "/favicon_hormesis/favicon-16x16.png"
        },
        logo: {
            path: hormesisLogo,
            width: "100px",
            height: "25px"
        },
        loader: {
            logo: hormesisLogo,
            width: "100px",
            height: "25px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'Ticket sales and event management for customers with special requirements',
                    'home.subtitle': 'Including seating, ticket scanning app and sales statistics',
                    'home.main_cta': 'Start selling'
                }
            },
            he: {
                terminology: {
                    'home.title': 'מכירת כרטיסים וניהול אירועים ללקוחות עם דרישות מיוחדות',
                    'home.subtitle': 'כולל הושבה, אפליקציית סריקת כרטיסים וסטטיסטיקות מכירות',
                    'home.main_cta': 'התחל למכור'
                }
            }
        }
    },
    'radical.org.il': {
        name: 'RADICAL',
        rootPath: '/auth/login',
        favicons: {
            apple: "https://radical.org.il/wp-content/uploads/2021/06/fav.png",
            large: "https://radical.org.il/wp-content/uploads/2021/06/fav.png",
            small: "https://radical.org.il/wp-content/uploads/2021/06/fav.png"
        },
        logo: {
            path: radicalLogo,
            width: "auto",
            height: "25px"
        },
        loader: {
            logo: radicalLogo,
            width: "auto",
            height: "25px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'Ticket sales and event management for customers with special requirements',
                    'home.subtitle': 'Including seating, ticket scanning app and sales statistics',
                    'home.main_cta': 'Start selling',
                    'event_page.season_ticket_discount_will_appear_after_choosing_tickets': 'Season ticket discount will appear after choosing tickets',
                    'sales_table_head.season_tickets': 'Members'
                }
            },
            he: {
                terminology: {
                    'home.title': 'מכירת כרטיסים וניהול אירועים ללקוחות עם דרישות מיוחדות',
                    'home.subtitle': 'כולל הושבה, אפליקציית סריקת כרטיסים וסטטיסטיקות מכירות',
                    'home.main_cta': 'התחל למכור',
                    'event_page.season_ticket_discount_will_appear_after_choosing_tickets': 'הנחת החברות תופיע לאחר בחירת הכרטיסים',
                    'sales_table_head.season_tickets': 'חברים'
                }
            }
        }
    },
    'zoatlv.co.il': {
        name: 'ZOA',
        favicons: {
            apple: "/favicon_zoa/apple-touch-icon.png",
            large: "/favicon_zoa/favicon-32x32.png",
            small: "/favicon_zoa/favicon-16x16.png"
        },
        logo: {
            path: zoaLogo,
            width: "100px",
            height: "45px"
        },
        loader: {
            logo: zoaLogo,
            width: "100px",
            height: "45px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'Ticket sales and event management for customers with special requirements',
                    'home.subtitle': 'Including seating, ticket scanning app and sales statistics',
                    'home.main_cta': 'Start selling'
                }
            },
            he: {
                terminology: {
                    'home.title': 'מכירת כרטיסים וניהול אירועים ללקוחות עם דרישות מיוחדות',
                    'home.subtitle': 'כולל הושבה, אפליקציית סריקת כרטיסים וסטטיסטיקות מכירות',
                    'home.main_cta': 'התחל למכור'
                }
            }
        }
    },
    'minkovsky-records.com': {
        name: 'MINKOVSKY',
        favicons: {
            apple: "/favicon_minkovsky/apple-touch-icon.png",
            large: "/favicon_minkovsky/favicon-32x32.png",
            small: "/favicon_minkovsky/favicon-16x16.png"
        },
        logo: {
            path: minkovskyLogo,
            width: "100px",
            height: "45px"
        },
        loader: {
            logo: minkovskyLogo,
            width: "100px",
            height: "45px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'Ticket sales and event management for customers with special requirements',
                    'home.subtitle': 'Including seating, ticket scanning app and sales statistics',
                    'home.main_cta': 'Start selling'
                }
            },
            he: {
                terminology: {
                    'home.title': 'מכירת כרטיסים וניהול אירועים ללקוחות עם דרישות מיוחדות',
                    'home.subtitle': 'כולל הושבה, אפליקציית סריקת כרטיסים וסטטיסטיקות מכירות',
                    'home.main_cta': 'התחל למכור'
                }
            }
        }
    },
    'comedyclub.co.il': {
        name: 'COMEDYCLUB',
        favicons: {
            apple: "/favicon/ccc_favicon.png",
            large: "/favicon/ccc_favicon.png",
            small: "/favicon/ccc_favicon.png"
        },
        logo: {
            path: comedyClubLogo,
            width: "120px",
            height: "60px"
        },
        loader: {
            logo: comedyClubLogo,
            width: "120px",
            height: "60px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'Ticket sales and event management',
                    'home.subtitle': 'Including season ticket, ticket scanning and sales statistics',
                    'home.main_cta': 'Start selling'
                }
            },
            he: {
                terminology: {
                    'home.title': 'מכירת כרטיסים וניהול אירועים',
                    'home.subtitle': 'כולל כרטיסייה, סריקת כרטיסים וסטטיסטיקות מכירות',
                    'home.main_cta': 'התחל למכור'
                }
            }
        }
    },
    'villaaccadia.com': {
        defaultLang: 'en',
        rootPath: '/auth/login',
        name: 'ACCADIA',
        favicons: {
            apple: "/favicon_accadia/apple-touch-icon.png",
            large: "/favicon_accadia/favicon.svg",
            small: "/favicon_accadia/favicon.svg"
        },
        logo: {
            path: accadiaLogo,
            width: "80px",
            height: "80px"
        },
        loader: {
            logo: accadiaLogo,
            width: "80px",
            height: "80px",
            color: "rgb(235, 80, 14)",
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'VILLA',
                    'home.subtitle': 'a place to be',
                    'home.main_cta': 'Admin Login',
                    'season_ticket.title': 'Membership',
                    'season_ticket.dialog.select_season_ticket': 'Select Membership',
                    'dashboard.season_ticket_status': 'Membership Status',
                    'dashboard.events.season_ticket': 'Membership',
                    'event_page.season_ticket_discount_will_appear_after_choosing_tickets': 'Membership discount will appear after choosing tickets',
                    'season_tickets_discount.title': 'Membership Discount',
                    'navigation.season_tickets_discount': 'Membership Discount',
                    'not_logged_in': 'Memebers access only',
                    'event_page.preloaded_user_data': 'Membership Owner',
                    'event_page.order_success': 'Your spot is confirmed',

                }
            },
            he: {
                terminology: {
                    'home.title': 'VILLA',
                    'home.subtitle': 'a place to be',
                    'home.main_cta': 'Admin Login',
                    'not_logged_in': 'גישה לממברס בלבד',
                    'event_page.preloaded_user_data': 'בעל המנוי',
                }
            }
        }
    },
    'adifplus.co.il': {
        name: 'ADIFPLUS',
        favicons: {
            apple: "/favicon_adifplus/favicon.png",
            large: "/favicon_adifplus/favicon.png",
            small: "/favicon_adifplus/favicon.svg"
        },
        logo: {
            path: adifplusLogo,
            width: "auto",
            height: "80px"
        },
        loader: {
            logo: adifplusLogo,
            width: "auto",
            height: "80px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'Adif+',
                    'home.subtitle': 'Conferences by the best lecturers',
                    'home.main_cta': 'Login'
                }
            },
            he: {
                terminology: {
                    'home.title': 'עדיף+',
                    'home.subtitle': 'כנסים מפי מיטב המרצים',
                    'home.main_cta': 'כניסה'
                }
            }
        }
    },
    'nimi.co.il': {
        name: 'NIMI',
        defaultCurrency: 'EUR',
        whiteLabel: false,
        favicons: {
            apple: "/favicon/apple-touch-icon.png",
            large: "/favicon/favicon-32x32.png",
            small: "/favicon/favicon-16x16.png"
        },
        logo: {
            path: nimiLogo,
            width: "auto",
            height: "55px"
        },
        loader: {
            logo: nimiLogo,
            width: "auto",
            height: "55px",
            color: "rgb(235, 80, 14)",
        },
        i18n: {
            en: {
                terminology: {
                    'home.name': ' Nimi ',
                    'home.title': 'Advanced system for ticket sales and community management',
                    'home.subtitle': 'We know that as a producer, you have special requests and we are here to answer all your needs quickly',
                    'home.main_cta': 'Book a demo'
                }
            },
            he: {
                terminology: {
                    'home.name': ' נימי ',
                    'home.title': 'מערכת מתקדמת למכירת כרטיסים וניהול קהילה',
                    'home.subtitle': 'אנחנו יודעים שבתור מפיק על, יש לך בקשות מיוחדות ואנחנו כאן כדי לענות על כל צורך שלך במהירות',
                    'home.main_cta': 'לקביעת דמו'
                }
            }
        }
    },
    'demo.nimi.co.il': {
        name: 'NIMI',
        defaultCurrency: 'NIS',
        whiteLabel: false,
        favicons: {
            apple: demoIcon,
            large: demoIcon,
            small: demoIcon
        },
        logo: {
            path: demoLogo,
            width: "auto",
            height: "55px"
        },
        loader: {
            logo: demoIcon,
            width: "auto",
            height: "55px",
            color: "#005c5b",
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'Advanced system for ticket sales and community management',
                    'home.subtitle': 'We know that as a producer, you have special requests and we are here to answer all your needs quickly',
                    'home.main_cta': 'Book a demo'
                }
            },
            he: {
                terminology: {
                    'home.title': 'מערכת מתקדמת למכירת כרטיסים וניהול קהילה',
                    'home.subtitle': 'אנחנו יודעים שבתור מפיק על, יש לך בקשות מיוחדות ואנחנו כאן כדי לענות על כל צורך שלך במהירות',
                    'home.main_cta': 'לקביעת דמו',
                    'seller_public.upcoming_events': 'כרטיסים'
                }
            }
        }
    },
    'tickets.jerusalemzoo.org.il': {
        name: 'JERUSALEM ZOO',
        defaultCurrency: 'ILS',
        rootPath: '/auth/login',
        favicons: {
            apple: demoIcon,
            large: demoIcon,
            small: demoIcon
        },
        logo: {
            path: demoLogo,
            width: "auto",
            height: "55px"
        },
        loader: {
            logo: demoIcon,
            width: "auto",
            height: "55px",
            color: "#005c5b",
        },
        i18n: {
            en: {
                terminology: {
                    'home.name': 'Jerusalem Zoo',
                    'home.title': 'Member ticketing and management',
                    'home.subtitle': 'Your membership portal',
                    'home.main_cta': 'Login'
                }
            },
            he: {
                terminology: {
                    'home.name': 'גן החיות הירושלמי',
                    'home.title': 'מערכת כרטיסים וניהול חברים',
                    'home.subtitle': 'פורטל החברות שלכם',
                    'home.main_cta': 'התחברות'
                }
            }
        }
    },
    'bambooclub.co.il': {
        name: 'BAMBOO CLUB',
        rootPath: '/seller/home',
        favicons: {
            apple: "/favicon_bambooclub/favicon.png",
            large: "/favicon_bambooclub/favicon.png",
            small: "/favicon_bambooclub/favicon.png"
        },
        logo: {
            path: bambooClubLogo,
            width: "auto",
            height: "80px"
        },
        loader: {
            logo: bambooClubLogo,
            width: "auto",
            height: "80px",
            color: "rgb(6, 67, 45)",
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': '',
                    'home.subtitle': 'The community designed to help you grow',
                    'home.main_cta': 'Login'
                }
            },
            he: {
                terminology: {
                    'home.title': '',
                    'home.subtitle': 'הקהילה שתעזור לך לצמוח',
                    'home.main_cta': 'כניסה'
                }
            }
        }
    },
    'articket.co.il': {
        name: 'ARTICKET',
        favicons: {
            apple: "/favicon_articket/favicon.png",
            large: "/favicon_articket/favicon.png",
            small: "/favicon_articket/favicon.png"
        },
        logo: {
            path: articketLogo,
            width: "auto",
            height: "80px"
        },
        loader: {
            logo: articketLogo,
            width: "auto",
            height: "80px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'Ticket sales and event management for customers with special requirements',
                    'home.subtitle': 'Including seating, ticket scanning app and sales statistics',
                    'home.main_cta': 'Start selling'
                }
            },
            he: {
                terminology: {
                    'home.title': 'מכירת כרטיסים וניהול אירועים ללקוחות עם דרישות מיוחדות',
                    'home.subtitle': 'כולל הושבה, אפליקציית סריקת כרטיסים וסטטיסטיקות מכירות',
                    'home.main_cta': 'התחל למכור'
                }
            }
        }
    },
    'app.flex.coach': {
        name: 'FLEX',
        favicons: {
            apple: flexLogo,
            large: flexLogo,
            small: flexLogo
        },
        logo: {
            path: flexLogo,
            width: "auto",
            height: "80px"
        },
        loader: {
            logo: flexLogo,
            width: "auto",
            height: "80px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.title': 'management software for fitness trainers',
                    'home.subtitle': 'start selling your coaching services',
                    'home.main_cta': 'Start selling'
                }
            },
            he: {
                terminology: {
                    'home.title': 'תוכנת ניהול מתאמנים למאמני כושר',
                    'home.subtitle': 'מנויים חודשיים, כרטיסים, הרשמה קלה ומהירה לשיעורים',
                    'home.main_cta': 'התחילו למכור עכשיו',
                    'wellness.registrants': 'הרשמה',
                    'header.events': 'שיעורים',
                    'seller_public.no_events': 'אין שיעורים',
                    'seller_public.subscription_usage_instructions': 'פשוט נכנסים לעמוד השיעורים בוחרים שיעור ונרשמים',
                    'seller_public.upcoming_events': 'שיעורים קרובים',
                    'book_event.success_message': 'נרשמת בהצלחה!',
                    'book_event.login_required_message': 'על מנת להירשם לשיעור זה, עליך להתחבר לחשבונך.',
                    'book_event.subscription_already_used_for_event': 'המנוי שלך כבר שומש עבור שיעור זה',
                    'book_event.subscription_not_configured_for_event': 'המנוי שלך אינו מוגדר עבור סוג השיעורים הזה',
                    'book_event.cannot_book_for_free': 'לא ניתן להירשם לשיעור זה עם המנוי הנוכחי שלך',
                }
            }
        }
    },
    'app.getnimi.com': {
        name: 'GET NIMI',
        rootPath: '/auth/start-selling',
        defaultLang: 'en',
        defaultCurrency: 'GBP',
        paymentProvider: 'stripe',
        poweredBy: {
            url: 'https://getnimi.com',
            name: 'getnimi.com',
        },
        favicons: {
            apple: "/favicon_getnimi/apple-touch-icon.png",
            large: "/favicon_getnimi/favicon-32x32.png",
            small: "/favicon_getnimi/favicon-16x16.png"
        },
        logo: {
            path: getnimiLogo,
            width: "auto",
            height: "55px"
        },
        loader: {
            logo: getnimiLogo,
            width: "auto",
            height: "55px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.name': 'Get Nimi',
                    'home.title': 'Advanced ticketing and community management',
                    'home.subtitle': 'Powerful tools for event organizers and community builders',
                    'home.main_cta': 'Get Started',
                    'auth.start_selling_success_message': 'Successfully registered! 🎉',
                    'auth.start_selling_success_message_description': 'Our team will review the details and approve you so you can start processing customers\nIn the meantime, you can start creating events 🚀',
                    'pricing.price_template': '£{{price}}',
                    'event_page.fixed_price_template': 'Fixed Price - £{{amount}}'
                }
            },
            he: {
                terminology: {
                    'home.name': 'גט נימי',
                    'home.title': 'מערכת מתקדמת למכירת כרטיסים וניהול קהילה',
                    'home.subtitle': 'כלים חזקים למארגני אירועים ובוני קהילות',
                    'home.main_cta': 'התחל',
                    'auth.start_selling_success_message': 'נרשמתם בהצלחה! 🎉',
                    'auth.start_selling_success_message_description': 'הצוות שלנו יעבור על הפרטים ויאשר אתכם כדי שתוכלו להתחיל לסלוק לקוחות\nבינתיים אתם יכולים להתחיל ליצור אירועים 🚀',
                    'pricing.price_template': '£{{price}}',
                    'event_page.fixed_price_template': 'מחיר קבוע - £{{amount}}',
                }
            }
        }
    },
    'tkt.tixw.com': {
        name: 'TIXW',
        defaultLang: 'he',
        defaultCurrency: 'ILS',
        whiteLabel: true,
        rootPath: '/auth/login',
        favicons: {
            apple: "/favicon_tixw/apple-touch-icon.png",
            large: "/favicon_tixw/favicon-32x32.png",
            small: "/favicon_tixw/favicon-16x16.png"
        },
        logo: {
            path: tixwLogo,
            width: "auto",
            height: "70px"
        },
        loader: {
            logo: tixwLogo,
            width: "auto",
            height: "70px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.name': 'TIXW',
                    'home.title': 'Ticket sales and event management',
                    'home.subtitle': 'Advanced ticketing system',
                    'home.main_cta': 'Start selling'
                }
            },
            he: {
                terminology: {
                    'home.name': 'TIXW',
                    'home.title': 'מכירת כרטיסים וניהול אירועים',
                    'home.subtitle': 'מערכת כרטוס מתקדמת',
                    'home.main_cta': 'התחל למכור'
                }
            }
        }
    },
    'firefly-members.com': {
        name: 'FIREFLY',
        rootPath: '/seller/fireflies',
        defaultLang: 'he',
        defaultCurrency: 'ILS',
        favicons: {
            apple: "/favicon_firefly/apple-touch-icon.png",
            large: "/favicon_firefly/favicon-32x32.png",
            small: "/favicon_firefly/favicon-16x16.png"
        },
        logo: {
            path: fireflyLogo,
            width: "auto",
            height: "70px"
        },
        loader: {
            logo: fireflyLogo,
            width: "auto",
            height: "47px",
            color: "#808080"
        },
        i18n: {
            en: {
                terminology: {
                    'home.name': 'FIREFLY',
                    'home.title': 'Ticket sales and event management',
                    'home.subtitle': 'Advanced ticketing system for members',
                    'home.main_cta': 'Login'
                }
            },
            he: {
                terminology: {
                    'home.name': 'FIREFLY',
                    'home.title': 'מכירת כרטיסים וניהול אירועים',
                    'home.subtitle': 'מערכת כרטוס מתקדמת לחברי מועדון',
                    'home.main_cta': 'התחברות'
                }
            }
        }
    },
    'circles-community.com': {
        name: 'CIRCLES',
        defaultLang: 'he',
        defaultCurrency: 'ILS',
        rootPath: '/seller/circles',
        favicons: {
            apple: "/favicon_circles/apple-touch-icon.png",
            large: "/favicon_circles/favicon-96x96.png",
            small: "/favicon_circles/favicon.ico"
        },
        logo: {
            path: circlesLogo,
            width: "auto",
            height: "70px"
        },
        loader: {
            logo: circlesLoaderLogo,
            width: "auto",
            height: "70px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.name': 'CIRCLES',
                    'home.title': 'Ticket sales and event management',
                    'home.subtitle': 'Advanced ticketing system',
                    'home.main_cta': 'Login'
                }
            },
            he: {
                terminology: {
                    'home.name': 'CIRCLES',
                    'home.title': 'מכירת כרטיסים וניהול אירועים',
                    'home.subtitle': 'מערכת כרטוס מתקדמת',
                    'home.main_cta': 'כניסה'
                }
            }
        }
    },
    'cloudtlv.com': {
        name: 'CLOUD',
        defaultCurrency: 'ILS',
        rootPath: '/seller/tlv',
        authImage: cloudtlvAuthImage,
        authImageMobile: cloudtlvAuthImageMobile,
        favicons: {
            apple: "/favicon_cloudtlv/apple-touch-icon.png",
            large: "/favicon_cloudtlv/favicon-32x32.png",
            small: "/favicon_cloudtlv/favicon-16x16.png"
        },
        logo: {
            path: cloudtlvLogo,
            width: "auto",
            height: "50px"
        },
        loader: {
            logo: cloudtlvLogo,
            width: "auto",
            height: "50px",
            color: "#3FA5DD"
        },
        i18n: {
            en: {
                terminology: {
                    'home.name': 'CLOUD',
                    'home.title': 'Ticket sales and event management',
                    'home.subtitle': 'Advanced ticketing system',
                    'home.main_cta': 'Login'
                }
            },
            he: {
                terminology: {
                    'home.name': 'CLOUD',
                    'home.title': 'מכירת כרטיסים וניהול אירועים',
                    'home.subtitle': 'מערכת כרטוס מתקדמת',
                    'home.main_cta': 'התחברות'
                }
            }
        }
    },
    'members.bohemaclub.com': {
        name: 'BOHEMA',
        defaultCurrency: 'ILS',
        rootPath: '/seller/namal',
        authImage: cloudtlvAuthImage,
        authImageMobile: cloudtlvAuthImageMobile,
        favicons: {
            apple: "/favicon_bohemaclub/apple-touch-icon.png",
            large: "/favicon_bohemaclub/favicon-32x32.png",
            small: "/favicon_bohemaclub/favicon-16x16.png"
        },
        logo: {
            path: bohemaClubLogo,
            width: "auto",
            height: "50px"
        },
        loader: {
            logo: bohemaClubLogo,
            width: "auto",
            height: "50px",
            color: "#FFDF99"
        },
        i18n: {
            en: {
                terminology: {
                    'home.name': 'BOHEMA',
                    'home.title': "Members' club",
                    'home.subtitle': 'Your membership portal',
                    'home.main_cta': 'Login'
                }
            },
            he: {
                terminology: {
                    'home.name': 'BOHEMA',
                    'home.title': 'מועדון החברים',
                    'home.subtitle': 'פורטל החברות שלכם',
                    'home.main_cta': 'התחברות'
                }
            }
        }
    },
    'events.michaelewis.com': {
        name: 'MICHAEL LOUISE',
        defaultLang: 'he',
        defaultCurrency: 'ILS',
        rootPath: '/auth/login',
        favicons: {
            apple: "/favicon_michaellouise/apple-touch-icon.png",
            large: "/favicon_michaellouise/favicon-32x32.png",
            small: "/favicon_michaellouise/favicon-16x16.png"
        },
        logo: {
            path: michaellouiseLogo,
            width: "auto",
            height: "70px"
        },
        loader: {
            logo: michaellouiseLogo,
            width: "auto",
            height: "70px"
        },
        i18n: {
            en: {
                terminology: {
                    'home.name': 'MICHAEL LOUISE',
                    'home.title': 'Ticket sales and event management',
                    'home.subtitle': 'Advanced ticketing system',
                    'home.main_cta': 'Start selling'
                }
            },
            he: {
                terminology: {
                    'home.name': 'MICHAEL LOUISE',
                    'home.title': 'מכירת כרטיסים וניהול אירועים',
                    'home.subtitle': 'מערכת כרטוס מתקדמת',
                    'home.main_cta': 'התחל למכור'
                }
            }
        }
    }
}

const domains = Object.keys(bootstrapData);

export { easytixLogo, hormesisLogo, radicalLogo, zoaLogo, minkovskyLogo, comedyClubLogo, bambooClubLogo, tixwLogo }

export const isNimi = () => {
    return window.location.host.includes('nimi') || window.location.search?.includes('nimi') || window.location.host.includes('localhost')
}

export const getMarketPlaceName = () => {
    return getBootstrapData().name;
}

export const getMarketPlaceEventPath = () => {
    return `${window.location.hostname}/event`
}


export const getMarketplaceLogo = () => {
    const { logo } = getBootstrapData();
    return logo || null;
}

export const getMarketplaceAuthImage = () => {
    return getBootstrapData().authImage || '/assets/images/auth/login.jpg';
}

export const getMarketplaceAuthImageMobile = () => {
    return getBootstrapData().authImageMobile || null;
}

// Cache for marketplace loader instances
let marketplaceLoaderCache = new Map();

export const getMarketplaceLoader = () => {
    const sellerPageLoaderImage = getSellerPageLoaderImage();
    const { loader } = getBootstrapData();
    // Create a cache key based on the loader configuration
    const cacheKey = JSON.stringify(loader);

    // Return cached instance if it exists
    if (marketplaceLoaderCache.has(cacheKey)) {
        return marketplaceLoaderCache.get(cacheKey);
    }

    // Create new instance and cache it
    const loaderInstance = createMarketplaceLoader(loader, sellerPageLoaderImage);
    marketplaceLoaderCache.set(cacheKey, loaderInstance);

    return loaderInstance;
}

export const getMarketPlaceTermsOfServiceAndPp = () => {
    return [DefaultTermsOfService, DefaultPrivacyPolicy]
}


export const getPageTitleByDomain = (title = "") => {
    if (title) {
        return `${title} | ${getMarketPlaceName()}`
    }
    return getMarketPlaceName()
}

export const getBootstrapData = () => {
    let { hostname } = window.location;
    if (hostname === 'localhost' || hostname === 'nimi.co.il') {
        // extract the fake domain from the query params
        const urlParams = new URLSearchParams(window.location.search);
        const fakeDomain = urlParams.get('domain');
        if (fakeDomain) {
            hostname = fakeDomain;
        }
    }

    if (bootstrapData[hostname]) {
        return bootstrapData[hostname]
    } else {
        return bootstrapData[domains.find(domain => hostname.endsWith(domain))] || bootstrapData['nimi.co.il']
    }
}

/**
 * Fetches i18n text for the current marketplace and language.
 * @param {string} key - Dot notation key, e.g., 'home.title' or 'terminology.some_key'
 * @param {string} lang - Language code, e.g., 'en' or 'he'
 * @returns {string|undefined}
 */
export function getMarketplaceI18nText(key, lang) {
    const data = getBootstrapData();
    if (!data.i18n || !data.i18n[lang]) return undefined;
    const parts = key.split('.');
    let value = data.i18n[lang];
    for (const part of parts) {
        if (value && typeof value === 'object' && part in value) {
            value = value[part];
        } else {
            return undefined;
        }
    }
    return value;
}